<template>
    <div>
        <Header />
        <Category />
        <div v-if="$store.state.hostName !== 'Q'">
            <Footer />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Category from '@/components/Category.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'CategoryView',

  components: {
    Header,
    Category,
    Footer
  }
}
</script>
